export default "__VITE_ASSET__CJdb2tiN__"